import * as React from 'react';
import styled from "styled-components";
import {Title, SectionTitle} from "../../styled"
import FunctionalTeachers from "./componetns/FunctionalTeachers";
import FunctionalStudents from "./componetns/FunctionalStudents";
import Teachers from "./componetns/Teachers";

const Container = styled.div`
  margin-left: 90px;
  
  ${Title} {
    max-width: none;
    margin-bottom: -20px;
  }

  @media screen and (max-width: 1270px) {
    margin: 0;
  }
`;

const Content = styled.div`
  display: grid;
  gap: 40px;
`;

/**
 * render landing page platform features section
 * @constructor
 */
export default function Possibilities(): React.ReactElement {
  return (
    <Container>
      <SectionTitle>возможности</SectionTitle>
      <Content>
        <Title>Функционал для преподавателя</Title>
        <FunctionalTeachers />
        <Title>Функционал для Студента</Title>
        <FunctionalStudents />
      </Content>
      <Teachers />
    </Container>
  );
}
